import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "sticky-header",
  class StickyHeader extends WYATTElement {
    connectedCallback() {
      this.header = document.querySelector("header");
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector("predictive-search");

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.addEventListener("scroll", this.onScrollHandler, false);

      this.createObserver();

      this.announceHeaderHeight();
    }

    disconnectedCallback() {
      this.removeEventListener(
        "preventHeaderReveal",
        this.hideHeaderOnScrollUp
      );
      window.removeEventListener("scroll", this.onScrollHandler);
    }

    announceHeaderHeight() {
      const headerHeight = this.header.getBoundingClientRect().height;
      document.documentElement.style.setProperty(
        "--header-height",
        `${headerHeight}px`
      );
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obsrvr) => {
        this.headerBounds = entries[0].intersectionRect;
        obsrvr.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds?.bottom
      ) {
        if (this.preventHide) {
          return;
        }

        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds?.bottom
      ) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          let isScrolling;

          window.clearTimeout(isScrolling);

          isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds?.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.setAttribute("sticky-hidden", true);
    }

    reveal() {
      this.header.setAttribute("sticky-visible", true);
      this.header.setAttribute("sticky-hidden", false);
    }

    reset() {
      this.header.setAttribute("sticky-visible", false);
      this.header.setAttribute("sticky-hidden", false);
    }
  }
);
